export default __webpack_public_path__ + "static/media/whatsapp.8f84e8ce.png";